import { Skeleton } from '@mui/material';
import { CatalogCardVariantKey } from '../../../../modules/catalogs/products/v2/sizing/catalogCardColumns.types';
import useGeneralSettingsStore from '../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { getMediaAspectRatio } from '../../../../utils/getMediaAspectRatio';
import { useProductCardV2Styles } from './productCardV2.styles';

interface FakeProductCardV2Props {
  size?: CatalogCardVariantKey;
}

const FakeProductCardV2 = ({ size }: FakeProductCardV2Props) => {
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);
  const { classes } = useProductCardV2Styles({ size });

  const isMediaOnly = size === CatalogCardVariantKey.SMALL;

  return (
    <div className={classes.root}>
      <div className={classes.mediaContainer}>
        <Skeleton
          variant="rectangular"
          sx={{ width: '100%', height: 0, paddingTop: getMediaAspectRatio(mediaFormat) }}
        />
      </div>

      {!isMediaOnly && (
        <div className={classes.fakeInfoSection}>
          <div className={classes.infoHeader}>
            <div className={classes.infoMain}>
              <div>
                <Skeleton width="85%" />
                <Skeleton width="35%" />
              </div>

              <div className={classes.fakeColorsRow}>
                {[0, 1, 2].map((key) => (
                  <Skeleton key={key} variant="circular" width={15} height={15} />
                ))}
              </div>
            </div>

            <Skeleton variant="circular" width={28} height={28} />
          </div>

          <Skeleton width="45%" />
        </div>
      )}
    </div>
  );
};

export default FakeProductCardV2;
